export const ALL_TAB_ID = 'All'

export enum NotificationTypes {
  Extraction = 'Extraction',
  Passport = 'Passport',
  Request = 'Request',
}

export interface SaiftyNotification {
  userId: string
  messageId: number
  data: any
  status: any
  messageType: string
  timestamp: number
}

export const NOTIFICATION_PREFIXES = {
  New: 'NEW_',
  Update: 'UPDATE_',
  Remove: 'REMOVE_',
}

export interface AssessmentProgressNotificationResult {
  progress: number
  total: number
}

export const NOTIFICATION_TO_CREATE_ASSESSMENT = 'FED_ASSESSMENT_CREATION'

export const NOTIFICATION_ASSESSMENT_PROGRESS = 'FED_ASSESSMENT_PROGRESS'

export const NOTIFICATION_TYPES = {
  NEW_RECORD_IN_APPROVAL: 'NEW_RECORD_IN_APPROVAL',
  // ...
}
